import {CLStore} from 'common/src/redux/store';
import {ZodTypeAny} from 'zod';
import {AgentName} from '../../copilot.enums';
import {plaintextContentResponseSchema} from '../../copilot.schemas';
import {Agent, Skill} from '../../copilot.types';
import getLLMModel from '../../models/utils/getLLMModel';
import {OpenAIModel} from '../../openAI/openAI.enums';
import {OpenAIModelConfig} from '../../openAI/openAI.models';
import buildAgentInstructions from '../../skills__invokeAgent/utils/buildAgentInstructions';
import agentBase from './agentBase';

interface Params {
  store: CLStore;
  getSkills: () => Skill[];
  name: AgentName;
  role: string;
  model?: OpenAIModelConfig;
  responseSchema?: ZodTypeAny;
}

export default function skills__agent({
  store,
  getSkills,
  name,
  role,
  model = getLLMModel(OpenAIModel.Gpt5_2),
  responseSchema = plaintextContentResponseSchema,
}: Params): Agent {
  const agentBaseObject = agentBase({
    name,
    role,
    instructions: buildAgentInstructions(role),
    model,
    responseSchema,
    getSkills,
  });

  return {
    ...agentBaseObject,
    name,
    scope: {inScope: [], outOfScope: []},
    __DEPRECATED_uiToolNames: [],
    contexts: [],
    store,
    conversationStarters: [],
  };
}
